module.exports = __webpack_public_path__ + "img/red_021.71056ea4.png";